module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_14.17fc35c6.jpg";